import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'QueryRoot', currentUser?: { __typename?: 'User', id: string, name: string } | null };


export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    name
  }
}
    `;

export function useCurrentUserQuery(options?: Omit<Urql.UseQueryArgs<CurrentUserQueryVariables>, 'query'>) {
  return Urql.useQuery<CurrentUserQuery, CurrentUserQueryVariables>({ query: CurrentUserDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCurrentUserQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ currentUser })
 *   )
 * })
 */
export const mockCurrentUserQuery = (resolver: ResponseResolver<GraphQLRequest<CurrentUserQueryVariables>, GraphQLContext<CurrentUserQuery>, any>) =>
  graphql.query<CurrentUserQuery, CurrentUserQueryVariables>(
    'CurrentUser',
    resolver
  )
